import React, { useState } from 'react';

import EditableText from 'components/Inputs/EditableText';

import { useCategoryContext } from 'components/CategoryList/CategoryContext';
import { useModalContext } from 'common/Context/ModalContext';
import { AmplitudeEventCategories, AmplitudeEventProperties, logAmplitudeEvent } from 'utils/Amplitude';
import styles from './AddCategory.module.scss';
import { extractCategoryName } from '../DoshiiMenuLogic/splitMenu';

const initText = '+ Add category';

type Props = {
  categoryNames: string[];
  menuName: string;
  usesDoshiiMenuLogic: boolean;
};
const AddCategory: React.FC<Props> = ({ categoryNames, usesDoshiiMenuLogic, menuName }) => {
  const { addNewCategory } = useCategoryContext();
  const { openModal } = useModalContext();

  const [text, setText] = useState(initText);

  const handleAdd = (text: string): void => {
    // We do not allow to create categories with doshii:menu:logic
    if (text.toLowerCase().startsWith('doshii:menu:')) {
      openModal({
        type: 'ERROR',
        canDismiss: true,
        title: 'This is not a valid category name.',
        body: 'Please choose another name.',
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        buttons: [{ label: 'OK', callback: () => {} }]
      });
      return;
    }
    // Check for duplicated
    if (categoryNames.some((name) => extractCategoryName(name) === text.toLowerCase())) {
      openModal({
        type: 'ERROR',
        canDismiss: true,
        title: 'This category name has already been used.',
        body: 'Please choose another name.',
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        buttons: [{ label: 'OK', callback: () => {} }]
      });
      return;
    }
    addNewCategory(usesDoshiiMenuLogic ? `doshii:menu:${menuName}:${text}` : text);
    logAmplitudeEvent({
      name: 'add category',
      category: AmplitudeEventCategories.MM_MENU,
      properties: {
        [AmplitudeEventProperties.MENU_NAME]: menuName,
        [AmplitudeEventProperties.CATEGORY_NAME]: text
      }
    });
  };
  const handleFocusOrBlur = (type: 'focus' | 'blur' | 'enter'): void => {
    if (type === 'focus') {
      setText('');
    } else {
      if (type === 'enter' && !!text.trim()) {
        handleAdd(text);
      }

      setText(initText);
    }
  };

  return (
    <div className={`${styles.Outer}`} data-testid="add-category">
      <h3>
        <EditableText
          text={text}
          placeholder="Category name"
          onStateChange={handleFocusOrBlur}
          onSubmit={setText}
          buttonStyle={styles.bigButton}
          hidePencil
        />
      </h3>
    </div>
  );
};

export default AddCategory;
